import { Popup } from 'devextreme-react';
import styled from 'styled-components';

export const PopupDx = styled(Popup)`
  .dx-popup-content {
    padding: 3px;
  }
`;
